// English message catalog. `pl.ts` must mirror these keys exactly.
export const en = {
  'app.title': 'GitexTrade',
  'nav.dashboard': 'Dashboard',
  'nav.positions': 'Positions',
  'nav.settings': 'Settings',
  'nav.watchlist': 'Watchlist',
  'nav.momentum': 'Momentum',
  'lang.toggle': 'PL',
  'alert.dismiss': 'Dismiss',
  'dashboard.killSwitch': 'Kill switch',
  'dashboard.engineIdle': 'Engine idle — no concrete adapters wired yet.',
  'dashboard.title': 'Quant Trading Dashboard',
  'dashboard.status': 'Engine Connection Status',
  'dashboard.active': 'Active (Alpaca API Paper Trading)',
  'dashboard.inactive': 'Idle (Missing API Credentials)',
  'dashboard.engineUnreachable': 'Idle (Engine Unreachable)',
  'dashboard.toggleUnreachable': 'Could not reach the trading engine. Is it still running?',
  'dashboard.pnl': 'Daily Unrealized PnL',
  'dashboard.charts': 'Live Price Charts (15m Timeframe)',
  'dashboard.positionsTitle': 'Current Positions',
  'dashboard.noPositions': 'No active positions reported by exchange.',
  'dashboard.summaryTitle': 'Active Quant Rules Summary',
  'settings.title': 'Quant Connection Settings',
  'settings.exchange': 'Active Exchange Adapter',
  'settings.alpacaKey': 'Alpaca API Key ID',
  'settings.alpacaSecret': 'Alpaca Secret Key',
  'settings.paper': 'Alpaca Paper Trading Mode',
  'settings.save': 'Apply & Save Settings',
  'settings.saved': 'Configuration successfully saved and applied!',
  'settings.strategyTitle': 'Technical Strategy parameters (Momentum)',
  'settings.riskTitle': 'Risk Controls & Volatility Allocation',
  'settings.sentimentTitle': 'Social Sentiment Filtering',
  'settings.emaFast': 'EMA Fast Period',
  'settings.emaSlow': 'EMA Slow Period',
  'settings.rsiPeriod': 'RSI Lookback Period',
  'settings.rsiOverbought': 'RSI Overbought Barrier',
  'settings.rsiOversold': 'RSI Oversold Barrier',
  'settings.hftTakeProfitPct': 'HFT Take Profit Level (%)',
  'settings.hftStopLossPct': 'HFT Stop Loss Level (%)',
  'settings.volPeriod': 'Volume SMA Period',
  'settings.volMult': 'Volume Spike Multiplier (x)',
  'settings.riskTrade': 'Risk Per Trade (% of Equity)',
  'settings.atrStop': 'ATR Stop Loss Multiple',
  'settings.maxPos': 'Max Parallel Positions',
  'settings.drawdown': 'Max Daily Loss Limit (%)',
  'settings.sentimentThresh': 'Sentiment Entry Gate Threshold',
  'settings.sentimentActive': 'Enable Sentiment Protection',
  'settings.geminiKey': 'Gemini API Key (Sentiment Analysis)',
  'settings.sendToServer': 'Send Keys to Local Server',
  'settings.serverConfigured': 'Server configured ✓ — API keys active',
  'settings.serverNotConfigured': 'Keys not sent to server yet',
  'settings.serverSection': 'Local Engine Server Configuration',
  'settings.serverUrl': 'Engine Server URL',
  'dashboard.startBot': 'Start Engine',
  'dashboard.stopBot': 'Stop Engine',
  'risk.panelTitle': 'Emergency Risk Controls',
  'risk.killSwitchOn': 'Engage Kill Switch',
  'risk.killSwitchOff': 'Release Kill Switch',
  'risk.killSwitchEngaged': 'Kill switch is ENGAGED — every trading cycle is blocked.',
  'risk.flatten': 'FLATTEN ALL',
  'risk.flattenConfirm': 'Confirm: close ALL positions?',
  'risk.flattenDone': 'All positions closed, engine halted.',
  'risk.flattenPartial': 'Some positions could not be closed — check the engine log.',
  'risk.flattenFailed': 'Flatten request failed. Is the engine reachable?',
  'risk.dailyBudget': 'Daily loss budget used',
  'risk.drawdownBudget': 'Portfolio drawdown budget used',
  'risk.breakerTripped': 'BREAKER TRIPPED',
  'dashboard.equity': 'Alpaca Account Equity',
  'dashboard.buyingPower': 'Buying Power',
  'dashboard.openPositions': 'Open Positions',
  'dashboard.symbol': 'Symbol',
  'dashboard.side': 'Side',
  'dashboard.quantity': 'Quantity',
  'dashboard.entryPrice': 'Entry Price',
  'dashboard.currentPrice': 'Current Price',
  'dashboard.unrealizedPnl': 'Unrealized PnL',
  'settings.strategyMode': 'Strategy Mode',
  'settings.activeStrategy': 'Currently running on the engine',
  'settings.unsavedStrategyWarning':
    'You picked a different strategy but haven’t saved it yet — the engine is still trading with the one above. Click "Apply & Save Settings" to activate your selection.',
  'settings.strategyMomentum': 'Momentum (Conservative)',
  'settings.strategyScalping': 'RSI Scalping (Aggressive)',
  'settings.strategyMomentumDesc': 'EMA cross 15m · 1-5 positions/week',
  'settings.strategyScalpingDesc': 'RSI bounces 5m · 5-15 positions/day',
  'settings.strategyFunding': 'Funding Rate Arbitrage (Crypto Delta-Neutral)',
  'settings.strategyFundingDesc': 'Spot Long + Perp Short · Earn from funding rate',
  'settings.strategyStatArb': 'ETH/BTC Stat Arb (Crypto Spread)',
  'settings.strategyStatArbDesc': 'Z-Score Mean Reversion · Spread asset trading',
  'settings.strategyMeanReversion': 'Mean Reversion (RSI dip-buy)',
  'settings.strategyMeanReversionDesc': 'Buy RSI oversold 15m · trades in any trend',
  'settings.strategyGitexTrade': 'GITEX TRADE (Smart Multi-Strategy)',
  'settings.strategyGitexTradeDesc': 'Evaluates all active strategies simultaneously in real-time and executes the one with the highest probability of success.',
  'settings.maxTotalDrawdown': 'Portfolio Stop — Max Total Loss (%)',
  'settings.alertsTitle': 'Alerts & Monitoring (Personal)',
  'settings.alertsDesc':
    'Each engine instance is yours alone — paste your own personal Telegram bot, Discord webhook, and UptimeRobot Heartbeat URL here. Friends running their own copy of this bot configure their own here, independently of yours.',
  'settings.telegramBotToken': 'Telegram Bot Token',
  'settings.telegramChatId': 'Telegram Chat ID',
  'settings.discordWebhookUrl': 'Discord Webhook URL',
  'settings.uptimerobotHeartbeatUrl': 'UptimeRobot Heartbeat URL',
  'settings.maxPosSize': 'Max Position Size (USD)',
  'settings.strategyHybrid': 'Hybrid (Dynamic Market Adapter)',
  'settings.strategyHybridDesc': 'ADX trend-strength routing · Momentum (>25) vs Mean Reversion (<20)',
  'settings.strategyAggressiveKoziel': 'Aggressive Koziel (Scalping)',
  'settings.strategyAggressiveKozielDesc': '1m candles · HMA(55) trend · Stochastic RSI crossovers <15/>85 · Volume impulse',
  'settings.strategyHftArbitrage': 'HFT / Arbitrage',
  'settings.strategyHftArbitrageDesc': 'Thousands of trades/day · 80%-99% Winrate · Micro-spread fractional profit target · High volume',
  'settings.strategySentimentMomentum': 'Sentiment Momentum (NASDAQ)',
  'settings.strategySentimentMomentumDesc': 'Trades the Top 5 NASDAQ Momentum Score watchlist (see Momentum tab) · EMA9/21 bullish cross + RSI band · Long-only, entry gated on Momentum Score >= threshold (default 0.6)',
  'tooltip.alpacaKey': 'Your personal Alpaca API key ID used to place orders.',
  'tooltip.alpacaSecret': 'Your personal Alpaca secret key used for authentication.',
  'tooltip.paper': 'Toggle paper trading mode to use paper (sandbox) environment.',
  'tooltip.strategyMode': 'Route your trading signals to momentum, scalping, mean reversion, or hybrid modes.',
  'tooltip.strategyGitexTrade': 'Aggregates all strategies and resolves conflicting entry signals using priority weights.',
  'tooltip.strategyMomentum': 'Trend-following strategy that enters when a fast Exponential Moving Average crosses above a slow Exponential Moving Average, confirmed by high volume.',
  'tooltip.strategyScalping': 'High-frequency strategy designed for short timeframes that enters when the Relative Strength Index bounce turns upward from the oversold zone.',
  'tooltip.strategyFunding': 'Delta-neutral strategy that holds a long position in the spot market and a short position in the perpetual swap market to earn funding rate payments.',
  'tooltip.strategyStatArb': 'Mean-reversion statistical arbitrage strategy trading the price ratio spread between Ethereum and Bitcoin using Z-score deviations.',
  'tooltip.strategyMeanReversion': 'Counter-trend strategy that buys when the Relative Strength Index drops into the oversold zone and begins turning upward, without trend confirmation requirements.',
  'tooltip.strategyHybrid': 'Dynamic adapter mode that calculates average market volatility using the Average Directional Index to route execution to either Momentum or Mean Reversion.',
  'tooltip.strategyAggressiveKoziel': 'Aggressive two-sided scalping (Long/Short) on 1-minute candles using HMA, Stochastic RSI crossovers, volume filters, custom exits, and a 5-minute cooldown.',
  'tooltip.strategyHftArbitrage': 'Ultra-high frequency market-making and micro-spread arbitrage strategy targeting fractions of a cent on massive trade counts, with tight micro-targets (+0.02% TP, -0.04% SL) and 1s execution cycle.',
  'tooltip.strategySentimentMomentum': 'Long-only NASDAQ strategy driven by the Momentum tab scanner: only evaluates the current Top 5 Momentum Score watchlist (Reddit/X/Finnhub sentiment + mention volume), enters on an EMA9/21 bullish cross inside the RSI band, and only if the Momentum Score clears the configurable threshold (default 0.6). Configure the data source API keys on the Momentum tab first — an empty watchlist means no trades.',
  'tooltip.emaFast': 'EMA Fast Period. [Strategies: All]. Defines short-term trend. Smaller values (e.g. 3) = more frequent buying / faster reactions in HFT/Scalping.',
  'tooltip.emaSlow': 'EMA Slow Period. [Strategies: All except HFT]. Defines medium-term trend to filter noise. Larger values = safer entries.',
  'tooltip.rsiPeriod': 'RSI Period. [Strategies: Momentum, Scalping, MR, HFT]. Computes momentum over a designated number of candles. Typically 14.',
  'tooltip.rsiOverbought': 'RSI Overbought level. [Strategies: Momentum, Scalping, MR]. Higher levels = less frequent exits / more buying in trend.',
  'tooltip.rsiOversold': 'RSI Oversold level. [Strategies: MR, Scalping]. Lower levels = deeper dips required to enter (safer entries).',
  'tooltip.volPeriod': 'Volume SMA Period. [Strategies: Momentum, Scalping, Kozieł]. Number of historical candles used to calculate average volume.',
  'tooltip.volMult': 'Volume Multiplier. [Strategies: Momentum, Scalping, Kozieł]. Higher values = safer but fewer entries requiring a strong volume spike.',
  'tooltip.riskTrade': 'Risk Per Trade. [Strategies: All except HFT]. Capital risked per trade based on ATR distance. Typically 1%.',
  'tooltip.atrStop': 'ATR Stop Loss Multiple. [Strategies: All except HFT]. Larger multiples = wider stop loss boundaries (less chance of early stop-out).',
  'tooltip.maxPos': 'Max Parallel Positions. [Strategies: All]. Raising this limit allows the bot to trade more assets simultaneously.',
  'tooltip.drawdown': 'Max Daily Loss. [Strategies: All]. Realized daily loss limit that triggers the engine kill-switch.',
  'tooltip.hftTakeProfitPct': 'HFT Take Profit Target percentage. Smaller values = faster profit capture and more frequent trading.',
  'tooltip.hftStopLossPct': 'HFT Stop Loss Limit percentage. Smaller values = less risk per trade, but more frequent exits.',
  'tooltip.maxPosSize': 'Maximum absolute USD amount allocated to a single trade.',
  'tooltip.maxTotalDrawdown': 'Stop the engine if start-equity drawdown drops past this percent limit.',
  'tooltip.sentimentThresh': 'Minimum sentiment score required to allow long position entry.',
  'tooltip.sentimentActive': 'Toggle sentiment filtering before entering new trades.',
  'tooltip.geminiKey': 'Gemini API key used to analyze news and calculate sentiment scores.',
  'tooltip.telegramBotToken': 'Telegram bot token from @BotFather for sending notifications.',
  'tooltip.telegramChatId': 'Telegram chat ID where notifications will be sent.',
  'tooltip.discordWebhookUrl': 'Discord webhook URL to stream trade actions to your channel.',
  'tooltip.uptimerobotHeartbeatUrl': 'UptimeRobot heartbeat ping URL to monitor bot loop health.',
  'tooltip.serverUrl': 'The base URL of your running trading engine instance (default: http://localhost:8000).',
  'footer.build': 'Build',
  'watchlist.title': 'Multi-Asset Watchlist',
  'watchlist.addAsset': 'Add Asset',
  'watchlist.symbol': 'Symbol',
  'watchlist.crypto': 'Cryptocurrency',
  'watchlist.stocks': 'Stock / ETF',
  'watchlist.actions': 'Actions',
  'watchlist.remove': 'Remove',
  'watchlist.addButton': 'Add',
  'watchlist.empty': 'No assets in this category.',
  'watchlist.successAdd': 'Asset added successfully.',
  'watchlist.successRemove': 'Asset removed successfully.',
  'watchlist.smartActive': 'Activate Smart Hot Watchlist',
  'watchlist.smartActiveMsg': 'Watchlist is managed dynamically by the Smart momentum scanner. Manual editing is disabled.',
  'tooltip.smartActive': 'When enabled, the watchlist is automatically synchronized with momentum-ranked, high-volume, high-liquidity assets (Top 100 Crypto / Top 1000 Stocks) checked for Alpaca trading rules.',
  'analytics.title': 'Performance Analytics',
  'analytics.timeframe': 'Timeframe',
  'analytics.loading': 'Loading trade history from Alpaca…',
  'analytics.error': 'Could not load performance analytics. Is the engine reachable?',
  'analytics.empty': 'No closed trades in this timeframe yet.',
  'analytics.netPnl': 'Net PnL',
  'analytics.winRate': 'Win rate',
  'analytics.profitFactor': 'Profit factor',
  'analytics.sharpe': 'Sharpe ratio',
  'analytics.maxDrawdown': 'Max drawdown',
  'analytics.avgDuration': 'Avg trade duration',
  'analytics.equityCurve': 'Equity curve',
  'analytics.pnlHistogram': 'PnL distribution',
  'analytics.winLoss': 'Win / loss',
  'analytics.wins': 'Wins',
  'analytics.losses': 'Losses',
  'analytics.trades': 'trades',
  'analytics.dataTable': 'Data table',
  'analytics.tableTime': 'Time',
  'analytics.tableEquity': 'Equity',
  'analytics.outOf': 'out of',
  'analytics.tradeCount': 'Trade Count',
  'analytics.pnlBracket': 'PnL Bracket',
  'topMovers.title': 'Top 5 NASDAQ Momentum',
  'topMovers.loading': 'Loading momentum movers…',
  'topMovers.error': 'Could not load momentum scores.',
  'topMovers.empty': 'No NASDAQ momentum movers yet — waiting for the next scan.',
  'topMovers.rank': 'Rank',
  'topMovers.symbol': 'Symbol',
  'topMovers.momentumScore': 'Momentum Score',
  'tooltip.momentumScore':
    'A 0–1 ranking blending recent bullish/bearish sentiment (Reddit r/wallstreetbets, X/Twitter, Finnhub news headlines) with how many mentions a symbol is getting right now versus its own recent average — the same role RVOL plays for price/volume momentum. Only NASDAQ symbols with at least 3 combined mentions in the scan window are scored; a value of 1.0 means maximally bullish and unusually high mention volume. In the sentiment_momentum strategy mode, a symbol only opens a long position once its score clears the configurable threshold (default 0.6).',
  'topMovers.mentionCount': 'Mentions',
  'topMovers.marketOpen': 'NASDAQ open',
  'topMovers.marketClosed': 'NASDAQ closed',
  'topMovers.diag.title': 'Diagnostics — what is not working',
  'topMovers.diag.error': 'Could not load diagnostics.',
  'topMovers.diag.reddit': 'Reddit',
  'topMovers.diag.twitter': 'Twitter/X',
  'topMovers.diag.finnhub': 'Finnhub',
  'topMovers.diag.tradingview': 'TradingView scan',
  'topMovers.diag.lastScan': 'Last scan',
  'topMovers.diag.never': 'never',
  'topMovers.diag.candidates': 'NASDAQ candidates',
  'topMovers.diag.mentionsReddit': 'Reddit mentions',
  'topMovers.diag.mentionsTwitter': 'Twitter mentions',
  'topMovers.diag.mentionsNews': 'News headlines',
  'topMovers.diag.topMoversFound': 'Movers found',
  'topMovers.config.title': 'Data source keys',
  'topMovers.config.redditClientId': 'Reddit Client ID',
  'topMovers.config.redditClientSecret': 'Reddit Client Secret',
  'topMovers.config.twitterBearerToken': 'X/Twitter Bearer Token',
  'topMovers.config.finnhubApiKey': 'Finnhub API Key',
  'topMovers.config.save': 'Save keys',
  'topMovers.config.saving': 'Saving…',
  'topMovers.config.saved': 'Momentum source keys saved.',
  'topMovers.config.saveError': 'Could not save momentum source keys.',
  'topMovers.console.title': 'Live console — scanner activity',
  'topMovers.console.error': 'Could not load the scanner console.',
  'topMovers.console.empty': 'No scanner activity logged yet. Waiting for the next scan…',
  'topMovers.console.clear': 'Clear console',
  'topMovers.scanNow': 'Scan now',
  'topMovers.scanRunning': 'Scanning…',
  'topMovers.scanError': 'Manual scan failed to start. Check the console below for details.',
  'topMovers.engine.active': 'Engine running',
  'topMovers.engine.modeActive': 'sentiment_momentum mode active',
  'topMovers.engine.modeInactive': 'Mode',
  'topMovers.engine.error': 'Could not load engine status.',
} as const;

export type MessageKey = keyof typeof en;
